import { Typography } from "@mui/material";
import { motion } from "framer-motion";

import {
  MOTION_VAR_INITIAL,
  MOTION_VAR_ANIMATE,
  LIST_ANIMATE_VARIANTS,
} from "@constants/Animation.constants.js";
import Spinner from "@common-components/Spinner/Spinner";
import ErrorMessage from "@common-components/ErrorMessage/ErrorMessage";
import SwitchDrawingButton from "@components/SwitchDrawingButton/SwitchDrawingButton";
import PrintMenu from "@components/PrintMenu/PrintMenu";
import OrientationSelectionGroup from "@components/OrientationSelectionGroup/OrientationSelectionGroup";
import StyleSelectionGroup from "@components/StyleSelectionGroup/StyleSelectionGroup";
import OptionPageNavbar from "@components/OptionPageNavbar/OptionPageNavbar";

const OptionPageLeftPanel = ({
  isTablet,
  isLeftPanelOpen,
  selectedTab,
  onModelSelect,
  currentUserRole,
  modelName,
  isLoading,
  setIsLoading,
  error,
  setError,
  pdfViewerArray,
  printAllPDFViewerArray,
  selectedStyle,
  selectedProject,
  selectedModel,
  selectedOrientation,
  handleOrientationChange,
  styleOptions,
  handleStyleSelection,
  renderMandatoryOptions,
  renderNonMandatoryOptions,
}) => {
  return (
    <div className="OptionPage__container--left">
      <OptionPageNavbar />
      <div
        className={`OptionPage__controlPanel${
          isTablet ? (isLeftPanelOpen ? " active-panel" : " hide-panel") : ""
        }`}
      >
        {/* SwitchDrawingButton component */}
        {/* {selectedTab === "COORDINATION" || selectedTab === "DESIGN" ? (
          <SwitchDrawingButton
            currentSelectedTab={selectedTab}
            onModelSelect={onModelSelect}
          />
        ) : (
          ""
        )} */}

        {/* Header Container */}
        <div className="OptionPage__leftContainer--header">
          {/* Option Page Title */}
          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              color: "title.main",
              textAlign: "center",
              fontSize: "1.5rem",
              width: "85%",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >{`${currentUserRole !== "SALES" && !currentUserRole?.startsWith("SALES_") ? selectedModel?.code : ""} ${modelName} ${currentUserRole !== "SALES" && !currentUserRole?.startsWith("SALES_") ? selectedModel?.selectedVersion : ""}`}</Typography>

          {/* Download Button */}
          <div className="OptionPage__leftContainer--downloadbtn">
            {isLoading.mergePDF ? (
              <Spinner />
            ) : error.mergePDF ? (
              <ErrorMessage>{error.mergePDF}</ErrorMessage>
            ) : (
              <PrintMenu
                pdfViewerArray={pdfViewerArray}
                printAllPDFViewerArray={printAllPDFViewerArray}
                selectedTab={selectedTab}
                selectedStyle={selectedStyle}
                selectedProjectName={selectedProject?.name}
                selectedModel={selectedModel}
                selectedOrientation={selectedOrientation}
                setIsLoading={setIsLoading}
                setError={setError}
              />
            )}
          </div>
        </div>

        {/* Selection Panel */}
        <div className="OptionGroup__container--selection">
          <div className="OptionGroup__selection--groupsList">
            <h3 className="OptionGroup__selection--title">Lot Conditions</h3>
            {isLoading.options ? (
              <div style={{ height: "5vh" }}>
                <Spinner />
              </div>
            ) : error.options || error.allPPOlist ? (
              <ErrorMessage>{error.options || error.allPPOlist}</ErrorMessage>
            ) : (
              <motion.div
                initial={MOTION_VAR_INITIAL}
                animate={MOTION_VAR_ANIMATE}
                variants={LIST_ANIMATE_VARIANTS.variants}
                transition={LIST_ANIMATE_VARIANTS.transition}
              >
                {/* Orientation Selection */}
                <div className="OptionGroup__container">
                  <h4 className="OptionGroup__title">Orientation</h4>
                  <OrientationSelectionGroup
                    selectedOrientation={selectedOrientation}
                    handleOrientationChange={handleOrientationChange}
                  />
                </div>

                {/* Style Selection */}
                <div className="OptionGroup__container">
                  <h4 className="OptionGroup__title">Style</h4>
                  <StyleSelectionGroup
                    styleOptions={styleOptions}
                    selectedStyle={selectedStyle}
                    handleStyleSelection={handleStyleSelection}
                  />
                </div>

                {/* Mand Option Selection */}
                <>{renderMandatoryOptions}</>
              </motion.div>
            )}
          </div>

          {/* Design Options (Non-Mand) */}
          <div className="OptionGroup__selection--groupsList">
            <h3 className="OptionGroup__selection--title">Options</h3>
            {isLoading.options ? (
              <div style={{ height: "5vh" }}>
                <Spinner />
              </div>
            ) : error.options || error.allPPOlist ? (
              <ErrorMessage>{error.options || error.allPPOlist}</ErrorMessage>
            ) : (
              <motion.div
                initial={MOTION_VAR_INITIAL}
                animate={MOTION_VAR_ANIMATE}
                variants={LIST_ANIMATE_VARIANTS.variants}
                transition={LIST_ANIMATE_VARIANTS.transition}
              >
                {renderNonMandatoryOptions}
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptionPageLeftPanel;
